import React, { forwardRef, useContext } from 'react';
import { Text as NativeText, TextInput as NativeTextInput, StyleSheet, type TextProps, type TextInputProps, type TextStyle, type StyleProp } from 'react-native';
import { AppearanceTypographyContext, AppearancePreviewContext } from '../theme/AppearanceContext';
import { appearanceFontFamily } from '../theme/appearance';
import type { AppTheme } from '../theme';

export function appearanceTextStyle(style: StyleProp<TextStyle>, typography: AppTheme['typography']): StyleProp<TextStyle> {
  if (typography.family === 'system' && typography.scale === 1 && typography.letterSpacing === 0) return style;
  const flat = StyleSheet.flatten(style) || {};
  return [style, {
    ...(!flat.fontFamily && typography.family !== 'system' ? { fontFamily: appearanceFontFamily(typography.family) } : {}),
    ...(typeof flat.fontSize === 'number' ? { fontSize: flat.fontSize * typography.scale } : {}),
    ...(typeof flat.lineHeight === 'number' ? { lineHeight: flat.lineHeight * typography.scale } : {}),
    ...(typography.letterSpacing !== 0 ? { letterSpacing: (flat.letterSpacing || 0) + typography.letterSpacing } : {}),
  }];
}
export type Text = NativeText;
export type TextInput = NativeTextInput;
export const Text = forwardRef<NativeText, TextProps & { studioStyle?: StyleProp<TextStyle> }>(({ studioStyle, ...props }, ref) => {
  const typography = useContext(AppearanceTypographyContext);
  const preview = useContext(AppearancePreviewContext);
  return <NativeText {...props} ref={ref} style={studioStyle ? [appearanceTextStyle(props.style, preview?.typography || typography), studioStyle] : appearanceTextStyle(props.style, preview?.typography || typography)} />;
});
export const TextInput = forwardRef<NativeTextInput, TextInputProps & { studioStyle?: StyleProp<TextStyle> }>(({ studioStyle, ...props }, ref) => {
  const typography = useContext(AppearanceTypographyContext);
  const preview = useContext(AppearancePreviewContext);
  return <NativeTextInput {...props} ref={ref} style={studioStyle ? [appearanceTextStyle(props.style, preview?.typography || typography), studioStyle] : appearanceTextStyle(props.style, preview?.typography || typography)} />;
});
Text.displayName = 'AppearanceText';
TextInput.displayName = 'AppearanceTextInput';
